import axiosInstance from './axiosInstance';
import {
  ListingSectionKey,
  ListingWizardSnapshot,
  SaveListingSectionPayload,
  SellerListingSummary,
} from '../../types/listing-wizard.types';

class ListingWizardService {
  private readonly baseUrl = '/seller/listings';

  async getSummaries(): Promise<SellerListingSummary[]> {
    const { data } = await axiosInstance.get<SellerListingSummary[]>(`${this.baseUrl}/summaries`);
    return data;
  }

  async getSnapshot(designId: string): Promise<ListingWizardSnapshot> {
    const { data } = await axiosInstance.get<ListingWizardSnapshot>(`${this.baseUrl}/${designId}/wizard`);
    return data;
  }

  async saveSection<T extends ListingSectionKey>(
    designId: string,
    section: T,
    payload: SaveListingSectionPayload<T>['payload'],
  ) {
    const { data } = await axiosInstance.put(`${this.baseUrl}/${designId}/wizard`, {
      section,
      payload,
    });
    return data;
  }

  async saveStep(designId: string, step: number) {
    const { data } = await axiosInstance.patch(`${this.baseUrl}/${designId}/wizard/step`, {
      step,
    });
    return data;
  }

  async publish(designId: string, publishAt?: string | null) {
    const { data } = await axiosInstance.post(`${this.baseUrl}/${designId}/publish`, {
      publishAt,
    });
    return data;
  }

  async updateAvailability(
    designId: string,
    body: {
      action: 'pause' | 'resume' | 'set_distribution';
      distribution?: 'public' | 'unlisted';
    },
  ) {
    const { data } = await axiosInstance.patch(
      `${this.baseUrl}/${designId}/availability`,
      body,
    );
    return data as {
      designId: string;
      listingId: string;
      status: SellerListingSummary['status'];
      visibility: SellerListingSummary['visibility'];
      updatedAt: string | null;
    };
  }
}

export const listingWizardService = new ListingWizardService();

